import Forward10Icon from "@mui/icons-material/Forward10";
import PauseIcon from "@mui/icons-material/Pause";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import Replay10Icon from "@mui/icons-material/Replay10";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  CardMedia,
  IconButton,
  Slider,
  Stack,
  Typography,
} from "@mui/material";
import moment from "moment/moment";
import React, { useEffect, useRef, useState } from "react";
import Loader from "../../../../common/Loader";
import { useSelector } from "react-redux";

function AudioViewer({ file, showDetails }) {
  const [isPaused, setIsPaused] = useState(true);
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const audioRef = useRef(null);
  const [loader, setLoader] = useState(true);
  const { loginData, selectedClientData } = useSelector((state) => state?.main);

  // Update current time regularly
  useEffect(() => {
    const audio = audioRef.current;
    if (audio) {
      const updateCurrentTime = () => {
        setCurrentTime(audio.currentTime); // Continuously update the current time
      };

      if (!audio.paused) {
        const timeUpdateInterval = setInterval(updateCurrentTime, 100); // Update every 100ms
        return () => clearInterval(timeUpdateInterval); // Clear interval on unmount or pause
      }
    }
  }, [isPaused]); // Re-run when isPaused changes (i.e., when play/pause happens)

  const handlePausePlay = () => {
    const audio = audioRef.current;
    try {
      if (audio.paused) {
        audio.play();
        setIsPaused(false);
      } else {
        audio.pause();
        setIsPaused(true);
      }
    } catch (error) {
      console.log('handlePausePlay-> Error in Handling Pause Play: ',error);
    }
  };

  const handleForward = () => {
    const audio = audioRef.current;
    audio.currentTime = Math.min(audio.currentTime + 10, duration);
    setCurrentTime(audio.currentTime);
  };

  const handleBackward = () => {
    const audio = audioRef.current;
    audio.currentTime = Math.max(audio.currentTime - 10, 0);
    setCurrentTime(audio.currentTime);
  };

  // Set audio duration when metadata is loaded
  useEffect(() => {
    const audio = audioRef.current;
    if (audio) {
      const handleLoadedMetadata = () => {
        setDuration(audio.duration);
      };

      audio.addEventListener("loadedmetadata", handleLoadedMetadata);

      return () => {
        audio.removeEventListener("loadedmetadata", handleLoadedMetadata);
      };
    }
  }, []);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  return (
    <Box>
      <Box position={"relative"}>
        <CardMedia
          onLoadedMetadata={() => setLoader(false)}
          component="audio"
          src={file?.fileUrl}
          ref={audioRef}
        />
        {loader && (
          <div
            style={{
              position: "absolute",
              top: "30%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              fontSize: "4rem",
            }}
          >
            <Loader />
          </div>
        )}
      </Box>
      <div
        style={{
          top: "-85px",
          width: "100%",
          color: "red",
          display: "flex",
          justifyContent: "space-between",
          gap: "10px",
          alignItems: "center",
        }}
      >
        <Typography color="black">{formatTime(currentTime)}</Typography>
        <Slider
          value={(currentTime / duration) * 100 || 0}
          min={0}
          max={100}
          onChange={(e, newValue) => {
            const newTime = (newValue / 100) * duration;
            audioRef.current.currentTime = newTime;
            setCurrentTime(newTime);
          }}
          sx={{
            width: "100%",
            "& .MuiSlider-thumb": {
              backgroundColor: selectedClientData?.AccentColor,
            },

            "& .MuiSlider-track": {
              backgroundColor: selectedClientData?.AccentColor,
            },
          }}
        />
        <Typography color="black">{formatTime(duration)}</Typography>
      </div>
      <div
        style={{
          top: "-80px",
          display: "flex",
          justifyContent: "center",
          gap: "10px",
        }}
      >
        <IconButton onClick={handleBackward}>
          <Replay10Icon />
        </IconButton>
        <IconButton onClick={handlePausePlay}>
          {isPaused ? <PlayArrowIcon /> : <PauseIcon />}
        </IconButton>
        <IconButton onClick={handleForward}>
          <Forward10Icon />
        </IconButton>
      </div>
      {showDetails && (
        <Stack
          mt={0.5}
          sx={{
            wordSpacing: 1,
            lineHeight: "0.9rem",
            overflow: "scroll",
            scrollbarWidth: "none",
          }}
          onClick={(e) => {}}
        >
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
            className="other-stack-adjust"
          >
            <Stack direction={"row"} gap={1} alignItems={"center"}>
              <Avatar alt="Remy Sharp" src={file?.userProfilePicture} />
              <Typography>{file?.userName}</Typography>
            </Stack>
            <Typography>
              {moment(file?.dateCreated).format("MMMM DD, YYYY")}
            </Typography>
          </Stack>
          <Typography
            maxHeight={"100px"}
            overflow={"scroll"}
            variant="body2"
            mt={1}
          >
            {file?.description}
          </Typography>
        </Stack>
      )}
    </Box>
  );
}

export default AudioViewer;
